export const months = [
  { id: 1, nameES: 'Enero', nameShort: 'Ene', nameEN: 'January' },
  { id: 2, nameES: 'Febrero',nameShort: 'Feb', nameEN: 'February' },
  { id: 3, nameES: 'Marzo',nameShort: 'Mar', nameEN: 'March' },
  { id: 4, nameES: 'Abril',nameShort: 'Abr', nameEN: 'April' },
  { id: 5, nameES: 'Mayo',nameShort: 'May', nameEN: 'May' },
  { id: 6, nameES: 'Junio',nameShort: 'Jun', nameEN: 'June' },
  { id: 7, nameES: 'Julio',nameShort: 'Jul', nameEN: 'July' },
  { id: 8, nameES: 'Agosto',nameShort: 'Ago', nameEN: 'August' },
  { id: 9, nameES: 'Septiembre',nameShort: 'Sep', nameEN: 'September' },
  { id: 10, nameES: 'Octubre',nameShort: 'Oct', nameEN: 'October' },
  { id: 11, nameES: 'Noviembre',nameShort: 'Nov', nameEN: 'November' },
  { id: 12, nameES: 'Diciembre',nameShort: 'Dic', nameEN: 'December' }
];
